import { NAME } from './constants';

export const FETCH_REPORT_DETAILS = `${NAME}/FETCH_REPORT_DETAILS`;
export const FETCH_REPORT_DETAILS_FAILURE = `${NAME}/FETCH_REPORT_DETAILS_FAILURE`;
export const FETCH_REPORT_DETAILS_SUCCESS = `${NAME}/FETCH_REPORT_DETAILS_SUCCESS`;

export const SET_HAS_PERMALINK = `${NAME}/SET_HAS_PERMALINK`;
